export default __webpack_public_path__ + "static/Eccles-Symphony-ad-6640385a59c4f405f15a9d95433c4b4b.jpg";